import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorGreen, colorRed, colorText } from '../../../theme/palette';
/**
 * Componente de badge para tabelas
 * 
 * @param {Object} props
 * @param {string} props.label - Texto do badge
 * @param {string} props.variant - Variante do badge ('success', 'danger', 'default')
 * @param {string} props.size - Tamanho do badge ('sm', 'md', 'lg')
 */

const TableBadge = ({
  label,
  variant = 'default',
  size = 'sm'
}) => {
  return <BadgeContainer variant={variant} size={size}>
      {label}
    </BadgeContainer>;
};

TableBadge.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['success', 'danger', 'default']),
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
}; // Estilos

const BadgeContainer = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 0;
  min-width: 60px;
  text-align: center;
  
  ${props => {
  switch (props.variant) {
    case 'success':
      return `
          background-color: #d4edda;
          color: #155724;
          border: 1px solid #c3e6cb;
        `;

    case 'danger':
      return `
          background-color: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
        `;

    default:
      return `
          background-color: #e2e3e5;
          color: #383d41;
          border: 1px solid #d6d8db;
        `;
  }
}}
`;
export default TableBadge;